import { Component, Input, OnInit } from '@angular/core';
import { LoaderService } from 'src/modules/shared/services/loader.service';
import { ActionItemService } from '../_services/action-item.service';
import {PopupConfirmationComponent} from "../../shared/request/popup-confirmation/popup-confirmation.component";
import {Mode} from "../../shared/form-guide/utility/enums/enums";
import {PopupNotificationComponent} from "../../shared/request/popup-notification/popup-notification.component";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {CommonService} from "../../shared/services/common.service";

@Component({
  selector: 'app-action-item-grid',
  templateUrl: './action-item-grid.component.html',
  styleUrls: ['./action-item-grid.component.scss']
})
export class ActionItemGridComponent implements OnInit {

  @Input() RequestId: any;
  @Input() ReadOnly: boolean;

  actionItems: any[];
  noActionItems: boolean;

  constructor(private actionItemService: ActionItemService,
              private modalService: BsModalService,
              private commonService: CommonService) {
    this.noActionItems = true;
  }

  ngOnInit() {
    this.actionItemService.getActionItemsByRequestId(this.RequestId).subscribe(
      (response) => {
        this.actionItems = response.Result;
        if(this.actionItems.length)
          this.noActionItems = false;
      },
      (error) => {
        console.log(error);
      }
    );
  }
    workSpace: string;
    alertMsg: string;
    alertHeader: string;
    alertModalRef: BsModalRef;
    confirmModalRef: BsModalRef;
  save(item: any) {
    LoaderService.showLoader();
    this.actionItemService.save(item).subscribe(
      (response) => {
        this.showModal();
        LoaderService.hideLoader();
      },
      (error) => {
        console.log(error);
      }
    );
  }

    private showModal() {
        this.alertHeader = 'Successfully Saved';

        this.alertMsg = 'Action Item Has been saved Successfully';

        const initialState = {
            alertMode: Mode.Success,
            alertHeader: this.alertHeader,
            alertMassage: `${this.alertMsg}`,
            navigateOnExit: false,
            exitNavigationURL: '',
            enableNavigation: false,
            backLableText: '',
            navigationURL: '',
        };
        this.alertModalRef = this.modalService.show(PopupNotificationComponent, {
            initialState,
            ignoreBackdropClick: true,
            keyboard: false,
        });
        this.alertModalRef.content.closeBtnName = 'Close';
    }
}
